import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-6 py-20 md:py-28 text-center">
      <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-background-100 mb-6">
        <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
      </div>
      <h1 className="font-heading text-4xl md:text-6xl font-bold text-foreground-950 mb-3">404</h1>
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">页面未找到</h2>
      <p className="text-foreground-500 text-sm md:text-base max-w-md mx-auto mb-8">
        您访问的页面不存在或已被移动。您可以返回首页，或者浏览我们的热门内容。
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-line mr-2"></i>
          返回首页
        </Link>
        <Link
          to="/category/live"
          className="px-8 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
        >
          浏览赛事
        </Link>
      </div>
    </div>
  );
}